import { useQuery } from '@tanstack/react-query';
import {
  getLanguages, type LanguageFilters 
} from '../api';

export function useLanguages(filters?: LanguageFilters) {
  return useQuery({
    queryKey: ['languages', filters],
    queryFn: () => getLanguages(filters),
  });
}
